module.exports = __webpack_public_path__ + "static/media/downloads@1x.76a6f4c0.mov";